export default "__VITE_PUBLIC_ASSET__37fd0c56__"